import React from 'react';
import ReactDOM from 'react-dom';
import Loading from '../Loading';
import SPINNER from '@/assets/images/page-loading-spinner.gif';

const PageIndicator = props => {
  return (
    <div
      className="fixed left-0 right-0 top-0 bottom-0 z-[10000] flex items-center justify-center bg-tint-white-700"
      style={{
        ...{ transform: 'translateZ(100px)' },
        ...props?.maskStyle
      }}>
      <Loading {...props} />
    </div>
  );
};

export default PageIndicator;

// common loading
export const showLoading = () => {
  if (typeof window === undefined) return;
  let div = document?.getElementById('loading');
  if (!div) {
    div = document.createElement('div');
    div.id = 'loading';
    document.body.appendChild(div);
    ReactDOM.render(<PageIndicator className="w-12 h-12" />, div);
  }
};

export const hideLoading = () => {
  if (typeof window === undefined) return;
  const div = document.getElementById('loading');
  if (div) {
    ReactDOM.unmountComponentAtNode(div);
    div.parentNode?.removeChild(div);
  }
};

// Loading spinner
export const loadingSpinner = () => {
  if (typeof window === undefined) return;
  let div = document?.getElementById('spinner-loading');
  if (!div) {
    div = document.createElement('div');
    div.id = 'spinner-loading';
    document.body.appendChild(div);
    ReactDOM.render(
      <PageIndicator maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} image={SPINNER} className="w-[120px]" />,
      div
    );
  }
};

export const hideSpinner = () => {
  if (typeof window === undefined) return;
  const div = document.getElementById('spinner-loading');
  if (div) {
    ReactDOM.unmountComponentAtNode(div);
    div.parentNode?.removeChild(div);
  }
};
